import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-print-account-statement',
  templateUrl: './print-account-statement.component.html',
styleUrls:  ['./print-account-statement.component.css']
})
export class PrintAccountStatementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
